import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';
import Logo from '../../assets/logo.png';

const CARET_DOWN = require('./caret-down.svg');

export default class LoadMore extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }


  componentDidUpdate(prevProps, prevState) {
    if(prevProps.page < this.props.page) {
      this.setState({
        loading: false,
      });
    }
  }

  _handleClick() {
    this.setState({
      loading: true,
    });
    setTimeout(() => {
      this.props.handler();
    }, 500);
  }

  render() {
    return (
      <div
        className={css(this.props.visible && styles.container : styles.hidden)}
        onClick={this._handleClick.bind(this)}>
       <div className={css(styles.text, this.state.loading ? styles.fadeout : false)}>
         Load more <img className={css(styles.image)} src={CARET_DOWN} />
       </div>
       {
         this.state.loading ? (
           <div className={'animate-flicker'}>
             <img src={Logo} className={css(styles.loading_image)} />
           </div>
         ) : false
       }
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    display: 'block',
    width: '100%',
    marginTop: 50,
    textAlign: 'center',
    fontFamily: Theme.fontFamily,
    fontWeight: 'bold',
    fontSize: 14,
    letterSpacing: 1,
    textTransform: 'uppercase',
    color: Theme.yellow,
    cursor: 'pointer',
    transition: 'all 480ms ease-in-out',
    ':hover': {
      opacity: 0.6,
    },
  },
  image: {
    marginLeft: 10,
  },
  loading_image: {
    marginTop: -30,
    height: 50,
  },
  fadeout: {
    opacity: 0,
  },
  hidden: {
    display: 'none',
    opacity: 0,
  }
})



// WEBPACK FOOTER //
// ./src/components/LoadMore/index.js